"use client";

import { c as _c } from "react/compiler-runtime";
import type React from "react";

// import PullToRefresh from "react-simple-pull-to-refresh";
// import { PopLoading } from "@/components/pop-ui/pop-loading";
// import { cn } from "@/lib/utils";

interface PullToRefreshWrapperProps {
  onRefresh: () => Promise<void>;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
}

/** @deprecated */
export function PullToRefreshWrapper(t0) {
  const $ = _c(2);
  const {
    children,
    disabled: t1
  } = t0;
  t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== children) {
    t2 = <>{children}</>;
    $[0] = children;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}